/**
 * Impresión de cocina configurable (fix 11/09 + pedido de Arturo). El DIAGNÓSTICO
 * del "por platillo" (3.er intento) mostró que el sellado, el feed y el render de
 * cocina están BIEN; el artefacto vivía en la impresión: SIN impresora de cocina,
 * cada "Enviar a cocina" abría un diálogo del navegador (window.print) — se
 * percibía "un ticket por renglón/envío".
 *
 * REGLA pura (testeable): la comanda se imprime SOLO si (a) hay una impresora de
 * cocina ACTIVA y (b) el override `printComanda` no está en false. Sin impresora
 * → NO se imprime ni se abre diálogo (default OFF). Con impresora → default ON.
 */
import { Printer } from './types';

export interface KitchenPrintDecision {
  print: boolean;
  /** por qué NO se imprime (para el confirm "sin impresión"). */
  reason: 'no-printer' | 'disabled' | null;
}

/** ¿hay una impresora de COCINA activa para esta estación/sucursal? */
export function hasKitchenPrinter(printers: Printer[] | null | undefined): boolean {
  return (printers ?? []).some((p) => p.isActive && p.role === 'cocina');
}

/**
 * Decide si imprimir la comanda. `printComanda` = override del tenant
 * (undefined/true = permitir; false = apagar aunque haya impresora).
 */
export function decideKitchenPrint(
  printers: Printer[] | null | undefined,
  printComanda: boolean | undefined,
): KitchenPrintDecision {
  if (!hasKitchenPrinter(printers)) return { print: false, reason: 'no-printer' };
  if (printComanda === false) return { print: false, reason: 'disabled' };
  return { print: true, reason: null };
}

/** Mensaje del confirm tras enviar a cocina (imprimió / sin impresión). */
export function kitchenSentMessage(itemCount: number, printed: boolean): string {
  const n = `${itemCount} ${itemCount === 1 ? 'ítem' : 'ítems'}`;
  return printed ? `Enviado a cocina (${n}).` : `Enviado a cocina · sin impresión (${n}).`;
}
